import React from 'react';
import { block } from 'bem-cn';

import './pion-content-typeplate.scss';
import { PionType, ImmutableMapItem } from '../../../type';

const b = block('pion-content-typeplate');

type PionTypePlateContentPropsType = {
  pion: Pick<PionType, keyof ImmutableMapItem | 'id' | 'title' | 'photo'>;
};
const PionTypePlateContent = ({ pion }: PionTypePlateContentPropsType) => {
  const photo = pion.get('photo');

  return (
    <div className={b()}>
      <div className={b('thumbnail')}>
        {photo && (
          <img
            data-testid='type-plate-thumbnail'
            src={photo.get('smallUrl')}
            alt={photo.get('caption')}
          />
        )}
      </div>
    </div>
  );
};

export default PionTypePlateContent;
